import React, { PropsWithChildren } from "react";
import { MosaicSuiteItem } from "./MosaicSuiteItem";
import { isPresent } from "src/utils/checks";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { ActivePromoForCruise } from "src/utils/promos";
import { useGeolocation } from "src/utils/localization/geolocation/GeolocationContext";
import * as styles from "./MosaicSuites.module.scss";
import { CruiseSectionShipVersionFragment } from "types/graphql-types";
import { CruisePriceAndOffersV2Response } from "src/ssc-api/prices/useCruisePrice";
import { CruiseSuiteOpenModalArgs } from "./SectionSuites";

type Props = {
  shipVersion: CruiseSectionShipVersionFragment;
  cruisePrice: CruisePriceAndOffersV2Response | undefined;
  cruiseCode: string;
  shipId: string;
  ecommerceStatus: ECommerceStatus;
  setOpenModal: (suite: CruiseSuiteOpenModalArgs) => void;
  activePromos: ActivePromoForCruise[];
  raqPagePath: string | undefined;
};

const MosaicSuites: React.FC<Props> = ({
  shipVersion,
  cruisePrice,
  cruiseCode,
  shipId,
  ecommerceStatus,
  setOpenModal,
  activePromos,
  raqPagePath
}) => {
  const geoLocation = useGeolocation();
  const sortedSuites = (shipVersion?.suites || []).filter(isPresent).reverse();

  return (
    <HorizontalMosaic>
      {sortedSuites.map((suite) => (
        <MosaicSuiteItem
          key={suite._key}
          suite={suite}
          cruisePrice={cruisePrice}
          raqPagePath={raqPagePath}
          cruiseCode={cruiseCode}
          shipId={shipId}
          ecommerceStatus={ecommerceStatus}
          unitSystem={geoLocation.unit}
          setOpenModal={setOpenModal}
          totalDecks={shipVersion?.totalDecks}
          activePromos={activePromos}
        />
      ))}
    </HorizontalMosaic>
  );
};

export default MosaicSuites;

const HorizontalMosaic: React.FC<PropsWithChildren<unknown>> = ({
  children
}) => <div className={styles.suiteList}>{children}</div>;
